// import React, { useEffect, useState, useRef } from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { ChevronUp } from "feather-icons-react/build/IconComponents";
// import { useDispatch, useSelector } from "react-redux";
// import { setToogleHeader } from "../../core/redux/action";
// import withReactContent from "sweetalert2-react-content";
// import Swal from "sweetalert2";
// import Table from "../../core/pagination/datatable";
// import { getAllProducts, deleteProduct } from "../../services/mainService";
// import Loader from "../loader/loader";
// import { useToast } from "../../Toaster/ToastContext";

// const LowStock = () => {
//   const dispatch = useDispatch();
//   const data = useSelector((state) => state.toggle_header);
//   const [loading, setLoading] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [activeTab, setActiveTab] = useState("low-stock");
//   const isDeleting = useRef(false);
//   const { showToast } = useToast();
//   const [permissions, setPermissions] = useState({
//     create: false,
//     read: false,
//     update: false,
//     delete: false,
//   });

//   const fetchlowStockProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await getAllProducts();
//       const productsData = response.data;
//       setProducts(productsData);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect(() => {
//   //   fetchlowStockProducts();
//   // }, []);
//   useEffect(() => {
//     fetchlowStockProducts();
//     const storedPermissions = localStorage.getItem("rolespermissions");
//     let parsedPermissions = [];
//     try {
//       const Permissions = JSON.parse(storedPermissions);
//       const getPermissions = JSON.parse(Permissions.permissions);
//       if (getPermissions.permissions) {
//         parsedPermissions = getPermissions.permissions;
//       } else {
//         parsedPermissions = getPermissions;
//       }

//       // Find Inventory section
//       const inventoryPermissions = parsedPermissions.find(
//         (item) => item.title === "Inventory"
//       );

//       // Find Low Stocks inside Inventory
//       const lowStockPermissions = inventoryPermissions?.childPage?.find(
//         (child) => child.title === "Low Stocks"
//       );

//       if (lowStockPermissions) {
//         setPermissions({
//           create: lowStockPermissions.create || false,
//           read: lowStockPermissions.read || false,
//           update: lowStockPermissions.update || false,
//           delete: lowStockPermissions.delete || false,
//         });
//       } else {
//         console.error("Low Stocks permissions not found in localStorage");
//         showToast(
//           "Low Stocks permissions not found.",
//           "error",
//           "Permissions Error"
//         );
//       }
//     } catch (error) {
//       console.error("Error parsing permissions from localStorage:", error);
//       showToast("Failed to load permissions.", "error", "Permissions Error");
//     }
//   }, []);

//   const renderCollapseTooltip = (props) => (
//     <Tooltip id="refresh-tooltip" {...props}>
//       Collapse
//     </Tooltip>
//   );

//   const columns = [
//     {
//       title: "Branch Name",
//       dataIndex: "branch_name",
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       sorter: (a, b) =>
//         (a.branch_name || "").localeCompare(b.branch_name || ""),
//       width: 200,
//     },
//     {
//       title: "Product",
//       dataIndex: "name",
//       render: (text, record) => {
//         const isExpired = new Date(record.expiry_on) < new Date();
//         return (
//           <span className="productimgname">
//             {record.image && record.image.length > 0 && (
//               <Link to="#" className="product-img stock-img">
//                 <ImageWithBasePath alt="" src={record.image[0]} />
//               </Link>
//             )}
//             <div
//               className="productDetails"
//               style={{ display: "flex", flexDirection: "column", gap: "4px" }}
//             >
//               <span
//                 className="product-name wrap-text"
//                 style={{ fontSize: "14px", fontWeight: 500 }}
//               >
//                 {text}
//               </span>
//               {isExpired && (
//                 <span
//                   className="expired-tag"
//                   style={{
//                     backgroundColor: "red",
//                     color: "white",
//                     padding: "2px 6px",
//                     borderRadius: "4px",
//                     fontSize: "10px",
//                     width: "fit-content",
//                     display: "inline-block",
//                   }}
//                 >
//                   Expired
//                 </span>
//               )}
//             </div>
//           </span>
//         );
//       },
//       sorter: (a, b) => a.name.localeCompare(b.name),
//       width: 200,
//     },
//     {
//       title: "Category",
//       dataIndex: "category_name",
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       sorter: (a, b) =>
//         (a.category_name || "").localeCompare(b.category_name || ""),
//       width: 200,
//     },
//     {
//       title: "Price",
//       dataIndex: "price",
//       render: (text) => <span className="wrap-text">PKR {text || "N/A"}</span>,
//       sorter: (a, b) => parseFloat(a.price) - parseFloat(b.price),
//       width: 200,
//     },
//     {
//       title: "Quantity",
//       dataIndex: "quantity",
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       sorter: (a, b) => a.quantity - b.quantity,
//       width: 100,
//     },
//   ];

//   // ✅ Add "Action" column only if delete permission exists
//   if (permissions.delete) {
//     columns.push({
//       title: "Action",
//       dataIndex: "actions",
//       key: "actions",
//       render: (_, record) => (
//         <div className="action-table-data">
//           <div className="edit-delete-action">
//             <Link className="confirm-text p-2" to="#">
//               <i
//                 data-feather="trash-2"
//                 className="feather-trash-2"
//                 onClick={() => showConfirmationAlert(record)}
//               ></i>
//             </Link>
//           </div>
//         </div>
//       ),
//       width: 100,
//     });
//   }

//   const MySwal = withReactContent(Swal);

//   const showConfirmationAlert = (record) => {
//     MySwal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       showCancelButton: true,
//       confirmButtonColor: "#00ff00",
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonColor: "#ff0000",
//       cancelButtonText: "Cancel",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           setLoading(true);
//           isDeleting.current = true;
//           const response = await deleteProduct(record.id);
//           const data = await response.json();
//           if (data.success) {
//             showToast(
//               "Product deleted successfully",
//               "success",
//               "Product Operation!"
//             );
//             await fetchlowStockProducts();
//           } else {
//             showToast(
//               data.message || "Failed to delete product",
//               "error",
//               "Product Operation!"
//             );
//           }
//         } catch (error) {
//           showToast(
//             error.message || "Failed to delete product",
//             "error",
//             "Product Operation!"
//           );
//         } finally {
//           setLoading(false);
//           isDeleting.current = false;
//         }
//       } else {
//         MySwal.close();
//       }
//     });
//   };

//   const [searchTerm, setSearchTerm] = useState("");

//   // Search handler
//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value.toLowerCase());
//   };

//   const getFilteredProducts = () => {
//     return products.filter((product) => {
//       const matchesTab =
//         activeTab === "low-stock"
//           ? product.quantity > 0 && product.quantity <= product.low_stock
//           : product.quantity === 0;

//       const matchesSearch =
//         (product.name && product.name.toLowerCase().includes(searchTerm)) ||
//         (product.branch_name &&
//           product.branch_name.toLowerCase().includes(searchTerm)) ||
//         (product.category_name &&
//           product.category_name.toLowerCase().includes(searchTerm));

//       return matchesTab && matchesSearch;
//     });
//   };

//   return (
//     <div>
//       <Loader loading={loading} />
//       <div className="page-wrapper">
//         <div className="content">
//           <div className="page-header">
//             <div className="page-title me-auto">
//               <h4>Low Stocks</h4>
//               <h6>Manage your low stocks</h6>
//             </div>
//             <ul className="table-top-head">
//               {/* <li>
//                                 <div className="status-toggle d-flex justify-content-between align-items-center">
//                                     <input type="checkbox" id="user2" className="check" defaultChecked="true" />
//                                     <label htmlFor="user2" className="checktoggle">
//                                         checkbox
//                                     </label>
//                                     Notify
//                                 </div>
//                             </li> */}
//               <li>
//                 <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
//                   <Link
//                     data-bs-toggle="tooltip"
//                     data-bs-placement="top"
//                     id="collapse-header"
//                     className={data ? "active" : ""}
//                     onClick={() => {
//                       dispatch(setToogleHeader(!data));
//                     }}
//                   >
//                     <ChevronUp />
//                   </Link>
//                 </OverlayTrigger>
//               </li>
//             </ul>
//           </div>
//           <div className="table-tab">
//             <ul className="nav nav-pills" id="pills-tab" role="tablist">
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={`nav-link ${
//                     activeTab === "low-stock" ? "active" : ""
//                   }`}
//                   onClick={() => setActiveTab("low-stock")}
//                   type="button"
//                   role="tab"
//                 >
//                   Low Stocks
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={`nav-link ${
//                     activeTab === "out-of-stock" ? "active" : ""
//                   }`}
//                   onClick={() => setActiveTab("out-of-stock")}
//                   type="button"
//                   role="tab"
//                 >
//                   Out of Stocks
//                 </button>
//               </li>
//             </ul>
//             <div className="tab-content" id="pills-tabContent">
//               <div className="tab-pane fade show active">
//                 <div className="card table-list-card">
//                   <div className="card-body">
//                     <div className="table-top">
//                       <div className="search-set">
//                         <div className="search-input">
//                           <input
//                             type="text"
//                             placeholder="Search by branch, product, or category"
//                             className="form-control form-control-sm formsearch"
//                             value={searchTerm}
//                             onChange={handleSearch}
//                           />

//                           <Link to className="btn btn-searchset">
//                             <i
//                               data-feather="search"
//                               className="feather-search"
//                             />
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="table-responsive">
//                       <Table
//                         columns={columns}
//                         dataSource={getFilteredProducts()}
//                         rowSelection={null}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LowStock;

import React, { useEffect, useState, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { getAllProducts, deleteProduct } from "../../services/mainService";
import Loader from "../loader/loader";
import { useToast } from "../../Toaster/ToastContext";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const LowStock = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [activeTab, setActiveTab] = useState("low-stock");
  const [searchTerm, setSearchTerm] = useState("");
  const isDeleting = useRef(false);
  const { showToast } = useToast();
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalCount: 0,
  });

  const fetchLowStockProducts = async () => {
    try {
      setLoading(true);
      const response = await getAllProducts();
      const productsData = response.data;
      setProducts(productsData);
    } catch (error) {
      console.error("Error fetching products:", error);
      showToast("Failed to fetch products.", "error", "Product Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLowStockProducts();
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);
      parsedPermissions = getPermissions.permissions
        ? getPermissions.permissions
        : getPermissions;

      const inventoryPermissions = parsedPermissions.find(
        (item) => item.title === "Inventory"
      );

      const lowStockPermissions = inventoryPermissions?.childPage?.find(
        (child) => child.title === "Low Stocks"
      );

      if (lowStockPermissions) {
        setPermissions({
          create: lowStockPermissions.create || false,
          read: lowStockPermissions.read || false,
          update: lowStockPermissions.update || false,
          delete: lowStockPermissions.delete || false,
        });
      } else {
        console.error("Low Stocks permissions not found in localStorage");
        showToast(
          "Low Stocks permissions not found.",
          "error",
          "Permissions Error"
        );
      }
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  useEffect(() => {
    const filtered = products.filter((product) => {
      const matchesTab =
        activeTab === "low-stock"
          ? product.quantity > 0 && product.quantity <= product.low_stock
          : product.quantity === 0;

      const matchesSearch =
        (product.name && product.name.toLowerCase().includes(searchTerm)) ||
        (product.branch_name &&
          product.branch_name.toLowerCase().includes(searchTerm)) ||
        (product.category_name &&
          product.category_name.toLowerCase().includes(searchTerm));

      return matchesTab && matchesSearch;
    });

    setFilteredProducts(filtered);
    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
      totalCount: filtered.length,
      totalPages: Math.ceil(filtered.length / prev.pageSize),
    }));
  }, [products, activeTab, searchTerm]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "branch_name",
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      sorter: (a, b) =>
        (a.branch_name || "").localeCompare(b.branch_name || ""),
      width: 200,
    },
    {
      title: "Product",
      dataIndex: "name",
      render: (text, record) => {
        const isExpired = new Date(record.expiry_on) < new Date();
        return (
          <span className="productimgname">
            {record.image && record.image.length > 0 && (
              <Link to="#" className="product-img stock-img">
                <ImageWithBasePath alt="" src={record.image[0]} />
              </Link>
            )}
            <div
              className="productDetails"
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <span
                className="product-name wrap-text"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                {text}
              </span>
              {isExpired && (
                <span
                  className="expired-tag"
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontSize: "10px",
                    width: "fit-content",
                    display: "inline-block",
                  }}
                >
                  Expired
                </span>
              )}
            </div>
          </span>
        );
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
      width: 200,
    },
    {
      title: "Category",
      dataIndex: "category_name",
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      sorter: (a, b) =>
        (a.category_name || "").localeCompare(b.category_name || ""),
      width: 200,
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (text) => <span className="wrap-text">PKR {text || "N/A"}</span>,
      sorter: (a, b) => parseFloat(a.price) - parseFloat(b.price),
      width: 200,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      sorter: (a, b) => a.quantity - b.quantity,
      width: 100,
    },
  ];

  if (permissions.delete) {
    columns.push({
      title: "Action",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="confirm-text p-2" to="#">
              <i
                data-feather="trash-2"
                className="feather-trash-2"
                onClick={() => showConfirmationAlert(record)}
              ></i>
            </Link>
          </div>
        </div>
      ),
      width: 100,
    });
  }

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          isDeleting.current = true;
          const response = await deleteProduct(record.id);
          const data = await response.json();
          if (data.success) {
            showToast(
              "Product deleted successfully",
              "success",
              "Product Operation"
            );
            await fetchLowStockProducts();
          } else {
            showToast(
              data.message || "Failed to delete product",
              "error",
              "Product Operation"
            );
          }
        } catch (error) {
          showToast(
            error.message || "Failed to delete product",
            "error",
            "Product Operation"
          );
        } finally {
          setLoading(false);
          isDeleting.current = false;
        }
      } else {
        MySwal.close();
      }
    });
  };

  const { currentPage, pageSize, totalPages, totalCount } = pagination;
  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalCount);
  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const pagesToShow = [];
  if (totalPages > 0) {
    if (totalPages <= 2) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (currentPage === 1) {
        middle = [1, 2];
      } else if (currentPage === totalPages) {
        middle = [totalPages - 1, totalPages];
      } else {
        middle = [currentPage, currentPage + 1];
      }

      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < totalPages - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < totalPages) {
        pagesToShow.push(totalPages);
      }
    }
  }

  const changePage = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title me-auto">
              <h4>Low Stocks</h4>
              <h6>Manage your low stocks</h6>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => dispatch(setToogleHeader(!data))}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className="table-tab">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "low-stock" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("low-stock")}
                  type="button"
                  role="tab"
                >
                  Low Stocks
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "out-of-stock" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("out-of-stock")}
                  type="button"
                  role="tab"
                >
                  Out of Stocks
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div className="tab-pane fade show active">
                <div className="card table-list-card">
                  <div className="card-body">
                    <div className="table-top">
                      <div className="search-set">
                        <div className="search-input">
                          <input
                            type="text"
                            placeholder="Search by branch, product, or category"
                            className="form-control form-control-sm formsearch"
                            value={searchTerm}
                            onChange={handleSearch}
                          />
                          <Link to="#" className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <Table
                        columns={columns}
                        dataSource={paginatedProducts}
                        rowSelection={null}
                        pagination={false}
                      />
                    </div>
                    {totalCount > 0 && (
                      <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4">
                        <div className="pagination-left">
                          Showing {startItem} - {endItem} of {totalCount}
                        </div>
                        <div className="pagination-right d-flex align-items-center">
                          <button
                            className="btn btn-sm btn-outline-secondary me-2"
                            disabled={currentPage === 1}
                            onClick={() => changePage(currentPage - 1)}
                          >
                            <LeftOutlined size={12} />
                          </button>
                          {pagesToShow.map((page, index) => (
                            <span key={index} className="me-2">
                              {page === "..." ? (
                                <span className="pagination-ellipsis">...</span>
                              ) : (
                                <button
                                  className={`btn btn-sm ${
                                    page === currentPage
                                      ? "btn-primary"
                                      : "btn-outline-secondary"
                                  }`}
                                  onClick={() => changePage(page)}
                                >
                                  {page}
                                </button>
                              )}
                            </span>
                          ))}
                          <button
                            className="btn btn-sm btn-outline-secondary ms-2"
                            disabled={currentPage === totalPages}
                            onClick={() => changePage(currentPage + 1)}
                          >
                            <RightOutlined size={12} />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LowStock;
